import { render, staticRenderFns } from "./RatingSetNew.vue?vue&type=template&id=339cb772"
import script from "./RatingSetNew.vue?vue&type=script&lang=js"
export * from "./RatingSetNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports